module.exports = __webpack_public_path__ + "img/图片12.c4120fcf.png";